<template>
  <tab-layout :full-width="true">
    <div slot="tabContent">
      <div class="bg-white rounded mb-4 p-3">
        <div class="index mb-5">
          <router-link
            :to="'/committees/dashboard/' + draftId"
          >
            back to Nomination Dashboard
          </router-link>
        </div>

        <page-heading>Event Members in {{ draftName }}</page-heading>

        <grid-table
          :columns="columns"
          :rows="members"
          :loading="loading"
          empty-text="No event members found."
        >
          <template #cell:number="{ row }">
            <small>#{{ row.memberNumber }}</small>
          </template>

          <template #cell:name="{ row }">
            <div>
              {{ row.primaryName }}
              <div v-for="sub in row.subMembers" :key="sub.id" class="small text-muted">
                {{ sub.name }}
                <span v-if="sub.upgraded" class="badge d-inline-block alert-success ml-1">Upgraded</span>
                <template v-else> (EM)</template>
                <span v-if="sub.scratched" class="badge d-inline-block alert-danger ml-1">Scratched</span>
              </div>
            </div>
          </template>

          <template #cell:contacts="{ row }">
            <div class="small">
              <div>{{ row.phone }}</div>
              <div>{{ row.email }}</div>
            </div>
          </template>

          <template #cell:cost="{ row }">${{ Math.round(row.totalCost) }}</template>

          <template #cell:invoice_status="{ row }">{{ row.invoiceSent ? 'Sent' : 'Not Sent' }}</template>

          <template #cell:payment_status="{ row }">
            <div v-if="row.hasInvoice">
              <div v-for="sub in row.subMembers" :key="sub.id">
                <span
                  class="badge d-inline-block"
                  :class="sub.paid ? 'alert-success' : 'alert-danger'"
                  style="width: 60px;"
                >{{ sub.paid ? 'Paid' : 'Not Paid' }}</span>
                <small>
                  {{ sub.name }}
                  <span v-if="sub.upgraded" class="badge d-inline-block alert-success ml-1">Upgraded</span>
                  <template v-else> (EM)</template>
                  <span v-if="sub.scratched" class="badge d-inline-block alert-danger ml-1">Scratched</span>
                </small>
              </div>
              <div>
                <span class="d-inline-block" style="width: 60px;" />
                <small>
                  <a
                    href="#"
                    @click.prevent="openPaymentModal(row)"
                  >
                    Update statuses
                  </a>
                </small>
              </div>
            </div>
            <span v-else class="text-muted small">Invoice not generated</span>
          </template>
        </grid-table>
      </div>

      <event-member-payment-modal
        v-if="selectedMember != null"
        :member="selectedMember"
        :draft-id="draftId"
        @close="selectedMember = null"
        @updated="fetchMembers"
      />
    </div>
  </tab-layout>
</template>

<script>
import { defineComponent, ref, computed, watch, getCurrentInstance, onMounted } from '@vue/composition-api'
import TabLayout from '@/components/TabLayout'
import PageHeading from '@/components/PageHeading'
import GridTable from '@/components/GridTable'
import EventMemberPaymentModal from '@/components/DraftEventMembers/EventMemberPaymentModal'
import useDraftEventMembers from '@/composables/draftEventMembers/useDraftEventMembers'

const COLUMNS = [
  { key: 'number', label: '', width: '0.5fr' },
  { key: 'name', label: 'Member name', width: '2fr', mobile: 'label' },
  { key: 'contacts', label: 'Contacts', width: '1.5fr', mobile: 'label' },
  { key: 'cost', label: 'Cost', width: '0.7fr', mobile: 'label' },
  { key: 'invoice_status', label: 'Invoice Status', width: '1fr', mobile: 'label' },
  { key: 'payment_status', label: 'Payment Status', width: '2fr', mobile: 'label' }
]

export default defineComponent({
  name: 'DraftEventMembers',
  components: { TabLayout, PageHeading, GridTable, EventMemberPaymentModal },
  setup() {
    const vm = getCurrentInstance()
    const draftId = computed(() => vm.proxy.$route.params.draftId)
    const selectedMember = ref(null)

    const { members, draftName, loading, fetchMembers } = useDraftEventMembers(draftId.value)

    watch(draftId, (id) => {
      if (id) fetchMembers()
    })

    onMounted(() => {
      if (draftId.value) fetchMembers()
    })

    function openPaymentModal(member) {
      selectedMember.value = member
    }

    return {
      columns: COLUMNS,
      draftId,
      draftName,
      members,
      loading,
      selectedMember,
      openPaymentModal,
      fetchMembers
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/views/DraftEventMembers/DraftEventMembers.vue